"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const selectors_1 = require("@/store/ducks/associatedComponents/selectors");
const listAssociatedComponents_1 = require("@/useCases/productsAssociation/listAssociatedComponents");
const index_view_1 = __importDefault(require("./index.view"));
function EditProductAssociationSection() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { productId } = (0, react_router_dom_1.useParams)();
    react_1.default.useEffect(() => {
        (0, listAssociatedComponents_1.listAssociatedComponents)(productId)(dispatch);
    }, []);
    const areAssociatedComponentsLoading = (0, react_redux_1.useSelector)(selectors_1.isAssociatedComponentsListLoading);
    const isAssociationLoading = (0, react_redux_1.useSelector)(selectors_1.isCreatingAssociationSelector);
    return (react_1.default.createElement(index_view_1.default, { areAssociatedComponentsLoading: areAssociatedComponentsLoading || isAssociationLoading }));
}
exports.default = EditProductAssociationSection;
